import React, { useRef, useState } from 'react';
import { Platform, TextInput, View } from 'react-native';
import { Text } from '..';
import { useStyleSheet } from '../../hooks';
import { createStyleSheet } from '../../utils';
export function PinInput({ value, onChange, disabled, onFinish, inputProps, error }) {
    const [focused, setFocused] = useState(0);
    const refs = useRef({});
    const styles = useStyleSheet(getStyles);
    const inputStyle = (Platform.OS === 'web' ? { outline: 'none' } : {});
    return (React.createElement(View, { style: styles.container },
        React.createElement(View, { style: styles.wrapper }, new Array(4).fill(0).map((_, i) => {
            return (React.createElement(View, { key: i, style: [
                    styles.inputWrapper,
                    i === 3 ? {} : styles.inputMargin,
                    focused === i ? styles.focused : {},
                    error ? styles.wrapperError : {},
                    disabled ? styles.disabled : {}
                ] },
                React.createElement(TextInput, Object.assign({ ref: (ref) => {
                        if (!ref)
                            return;
                        if (Platform.OS === 'web' && i === 0 && focused === 0)
                            ref.focus();
                        refs.current[i] = ref;
                    }, style: [styles.input, inputStyle], value: value.charAt(i), editable: !disabled, placeholder: '-', autoFocus: Platform.OS !== 'web' && i === 0, onKeyPress: (e) => {
                        var _a;
                        if (e.nativeEvent.key === 'Backspace') {
                            if (value.charAt(i) !== '') {
                                onChange(value.substring(0, value.length - 1));
                            }
                            if (i !== 0)
                                (_a = refs.current[i - 1]) === null || _a === void 0 ? void 0 : _a.focus();
                        }
                    }, onChangeText: (text) => {
                        var _a;
                        if (disabled || !text || /[^A-Za-z0-9]+/g.test(text))
                            return;
                        let newValue = '';
                        if (value.charAt(i) !== '') {
                            if (i === 3) {
                                newValue =
                                    value.substring(0, i) +
                                        text.charAt(1) +
                                        value.substring(i + 1);
                            }
                            else {
                                newValue = value + text.charAt(1);
                            }
                        }
                        else {
                            newValue = value + text;
                        }
                        if (newValue) {
                            onChange(newValue);
                            if (onFinish && newValue.length === 4)
                                onFinish(newValue);
                        }
                        if (i !== 3)
                            (_a = refs.current[i + 1]) === null || _a === void 0 ? void 0 : _a.focus();
                    }, onFocus: () => {
                        setFocused(i);
                    } }, inputProps))));
        })),
        error ? (React.createElement(Text, { type: 'body', size: 'md', weight: 'regular', style: styles.error }, error)) : null));
}
const getStyles = createStyleSheet(({ color, size }) => ({
    container: { alignItems: 'center' },
    wrapper: { flexDirection: 'row' },
    inputWrapper: {
        height: 53,
        width: 51,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        borderWidth: 1,
        borderColor: color.invert2.p4,
        borderRadius: size.C
    },
    disabled: { opacity: 0.56 },
    wrapperError: { borderColor: color.negative.ghostHover },
    error: { color: color.negative.solid, marginTop: size.G },
    focused: { borderWidth: 4 },
    input: {
        height: size.I,
        width: size.I,
        fontSize: 17,
        textAlign: 'center',
        backgroundColor: 'transparent',
        borderWidth: 0,
        color: color.invert2.p100,
        fontWeight: '600'
    },
    inputMargin: { marginRight: size.L }
}));
//# sourceMappingURL=index.js.map